import IDE from '@/IDE';
import { ErrorProvider } from '@/context/ErrorProvider';
import { MetadataProvider } from '@/context/MetadataProvider';
import { SelectedProvider } from '@/context/SelectedProvider';
import { UpdateNodesProvider } from '@/context/UpdateNodesProvider';
import { ViewportProvider } from '@/context/ViewportProvider';
import { SelectNode } from '@/types/backendNode';
import { OpenEditType } from '@/types/subroutine';
import { useState } from 'react';
import RestoredApplication from './RestoredApplication';
import BlockAppBar from './navigation/BlockAppBar';

const BlockEngineBuilder = () => {
  const [openEdit, setOpenEdit] = useState<OpenEditType>({ open: false });
  const [selectedNodeIdsSettings, setSelectedNodeIdsSettings] = useState<SelectNode[]>([]);

  return (
    <MetadataProvider>
      <RestoredApplication>
        <ViewportProvider>
          <ErrorProvider>
            <UpdateNodesProvider>
              <BlockAppBar openEdit={(open) => setOpenEdit(open)} closeDetails={() => setSelectedNodeIdsSettings([])} />
              <SelectedProvider>
                <IDE
                  openEdit={openEdit}
                  setOpenEdit={(open) => setOpenEdit(open)}
                  selectedNodeIdsSettings={selectedNodeIdsSettings}
                  setSelectedNodeIdsSettings={(newSettings) => {
                    setSelectedNodeIdsSettings([]);
                    setSelectedNodeIdsSettings(newSettings);
                  }}
                />
              </SelectedProvider>
            </UpdateNodesProvider>
          </ErrorProvider>
        </ViewportProvider>
      </RestoredApplication>
    </MetadataProvider>
  );
};

export default BlockEngineBuilder;
